import { render, staticRenderFns } from "./AVehicleStatusChanger.vue?vue&type=template&id=6cdaa49c"
import script from "./AVehicleStatusChanger.vue?vue&type=script&lang=js"
export * from "./AVehicleStatusChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports